// extracted by mini-css-extract-plugin
export default {"RemoveCustomerButtonContainer":"RemoveCustomerModal_RemoveCustomerButtonContainer__cSCrz","RemoveCustomerButtonElement":"RemoveCustomerModal_RemoveCustomerButtonElement__fM0FW"};